import { render, staticRenderFns } from "./NotificationItemView.vue?vue&type=template&id=3918fcc6&scoped=true&"
import script from "./NotificationItemView.vue?vue&type=script&lang=ts&"
export * from "./NotificationItemView.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationItemView.vue?vue&type=style&index=0&id=3918fcc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3918fcc6",
  null
  
)

export default component.exports